module.exports = __webpack_public_path__ + "img/thumbnail_Babirusa_j_normal.1881e6e4.png";